import { SupportThread } from '@/components/SupportPage/SupportThread'
import { Screen } from '@/ui/core/screen'

/** The care team thread as a tab: the same conversation, one tap from anywhere. */
export default function ChatScreen() {
	return (
		<Screen preset="fixed" className="flex flex-1" safeAreaEdges={[]}>
			<SupportThread />
		</Screen>
	)
}
